import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-dumbledores-letter-to-gringotts",
  name: `Dumbledore's Letter to the Gringotts Head Goblin`,
  origin: `Harry Potter and the Philosopher's Stone`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
